<template>
  <div class="gFolder" v-if="gFolder">
    <h5 class="subtitle">
      <bread-crumbs :autoLoad="true" :autoLoadStopAtIds="breadcrumbsAutoLoadStopAtIds" :gFolder="gFolder" :maxAge="-1"/>
    </h5>
    <div v-if="gFolder.description">{{gFolder.description}}</div>
    <div v-if="gFolderMeta">Last updated on {{gFolderMeta.lastUpdated | moment("dddd, MMMM Do YYYY, h:mm:ss a") }}
      - {{gFolderMeta.childrenStatus}}
      <template v-if="gFolderMeta.childrenStatus==='partial'">- <a href="#" @click.prevent.stop="loadMore">load more</a></template>
      - <a href="#" @click.prevent.stop="loadMore">refresh</a>
    </div>
    <div v-if="gFolderChildrenAll.length" class="row">
      <div class="count col-12">
        Loaded
        <template v-if="subFolderCount === 0">no subfolders</template>
        <template v-if="subFolderCount === 1">1 subfolder</template>
        <template v-if="subFolderCount > 1">{{subFolderCount}} subfolders</template>
        and
        <template v-if="(filesCount) === 0">no files.</template>
        <template v-if="(filesCount) === 1">1 file.</template>
        <template v-if="(filesCount) > 1">{{filesCount}} files.</template>
      </div>
      <div v-if="filesCount > 0" class="view col-12">
        <button class="btn show btn-sm btn-outline-primary" :class="{active:getGridView==='grid'}"  @click.stop.prevent="setView('grid')">View:Grid</button>
        <button class="btn show btn-sm btn-outline-primary" :class="{active:getGridView==='full'}" @click.stop.prevent="setView('full')">View:Full</button>
        <button class="btn show btn-sm btn-outline-primary" :class="{active:getGridView==='none'}" @click.stop.prevent="setView('none')">View:None</button>
      </div>
      <template v-for="file in gFolderChildrenMax">
        <g-files-in-folders-list v-if="file.mimeType==='application/vnd.google-apps.folder'"
          :breadcrumbsAutoLoadStopAtIds="breadcrumbsAutoLoadStopAtIds"
          :gFolder="gFilesMap[file.id]"
          :gFolderChildrenIds="gFilesMetaMap[file.id].children"
          :key="file.id"
          class="col-12"
          :depth="depth+1"
          />
        <g-file v-if="file.mimeType!=='application/vnd.google-apps.folder' && getGridView!=='none'" :key="file.id" :gFileId="file.id" class="col-12" :class="{ 'col-lg-6 col-xl-4': getGridView==='grid' }" />
      </template>
      <div v-if="getGridView!=='none' && maxAmountOfFilesDisplayed < gFolderChildrenIds.length" class="col-12" :class="{ 'col-lg-6 col-xl-4': getGridView==='grid' }">
        There are currently {{ gFolderChildrenIds.length-maxAmountOfFilesDisplayed }} more files loaded and ready to show.
        <a href="#" @click.stop.prevent="maxAmountOfFilesDisplayed=gFolderChildrenIds.length">Show all files.</a>
      </div>
    </div>
    <div v-else class="file">
      <template v-if="gFolderMeta && gFolderMeta.childrenStatus === 'partial'">[Partial load. Folder might be empty.]</template>
      <template v-if="gFolderMeta && gFolderMeta.childrenStatus === 'loading'">[Loading]</template>
      <template v-if="gFolderMeta && gFolderMeta.childrenStatus === 'complete'">[Load complete. Folder is empty]</template>
    </div>
  </div>
</template>

<script>
// import GFile from '@/components/GFile.vue'
import BreadCrumbs from '@/components/BreadCrumbs.vue'
import { GApiMixin } from '@/mixins/GApiMixin.js'
export default {
  name: 'GFilesInFoldersList',
  mixins: [GApiMixin],
  components: {
    BreadCrumbs
  },
  props: {
    // gFolderId: String,
    gFolder: Object,
    gFolderChildrenIds: Array,
    depth: {
      type: Number,
      default: 0
    },
    breadcrumbsAutoLoadStopAtIds: Array
  },
  data () {
    return {
      maxAmountOfFilesDisplayed: 10
    }
  },
  computed: {
    gFolderId () {
      return this.gFolder.id
    },
    gFolderMeta () {
      // if (!this.gFilesMetaMap[this.gFolder.id]) console.log('gFolderMeta undefined for: ', this.gFolder)
      return this.gFilesMetaMap[this.gFolder.id]
    },
    gFolderChildrenMax () {
      const amt = Math.min(this.maxAmountOfFilesDisplayed, this.gFolderChildrenIds.length)
      return this.gFolderChildrenAll.slice(0, amt)
    },
    gFolderChildrenAll () {
      const children = []
      // const amt = Math.min(this.maxAmountOfFilesDisplayed, this.gFolderChildrenIds.length)
      for (let i = 0; i < this.gFolderChildrenIds.length; i++) {
        if (Object.prototype.hasOwnProperty.call(this.gFilesMap, this.gFolderChildrenIds[i])) {
          children.push(this.gFilesMap[this.gFolderChildrenIds[i]])
        }
      }
      // return children
      const files = children.filter(files => files.mimeType !== 'application/vnd.google-apps.folder')
      const folder = children.filter(files => files.mimeType === 'application/vnd.google-apps.folder')
      const finalChildren = files.concat(folder)
      return finalChildren
    },
    subFolderCount () {
      const folders = this.gFolderChildrenAll.filter(files => files.mimeType === 'application/vnd.google-apps.folder')
      return folders.length
    },
    filesCount () {
      const files = this.gFolderChildrenAll.filter(files => files.mimeType !== 'application/vnd.google-apps.folder')
      return files.length
    },
    viewList () {
      return this.$store.state.settings.view
    },
    getGridView () { // get the current gridView
      const viewIndex = this.viewList.findIndex(obj => obj.id === this.gFolderId)
      if (viewIndex > -1 && typeof this.viewList[viewIndex].view === 'string') {
        return this.viewList[viewIndex].view
      } else {
        return 'grid'
      }
    }
  },
  methods: {
    loadMore () {
      // if (this.gFolderMeta.childrenNextPageToken) {
      //   this.getFilesInParentsNextPage(this.gFolderMeta.childrenNextPageToken, [this.gFolderId])
      // } else {
      this.getFilesInParents([this.gFolderId], true, true, true)
      // }
    },
    setView (view) { // toggle gridView based on current gridView of the folder
      // let gridView = this.getGridView
      // gridView = !gridView
      // console.log('setView: ', view)
      const val = {
        id: this.gFolderId,
        view: view
      }
      this.$store.commit('setView', val)
    }
  }
}
</script>
